export default "__VITE_PUBLIC_ASSET__609b31e3__"